import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

const ORPHAN_REGEX = /\b([AaIiKkOoSsUuVvZz])\s+(?=\S)/g;
const SKIP_TAGS = new Set(["SCRIPT", "STYLE", "TEXTAREA", "INPUT", "CODE", "PRE"]);

const replaceOrphansInTextNode = (node) => {
  if (!node || !node.nodeValue || !ORPHAN_REGEX.test(node.nodeValue)) {
    return;
  }
  node.nodeValue = node.nodeValue.replace(ORPHAN_REGEX, "$1\u00A0");
};

const fixOrphans = (rootNode) => {
  if (!rootNode) {
    return;
  }
  const walker = document.createTreeWalker(
    rootNode,
    NodeFilter.SHOW_TEXT,
    {
      acceptNode(node) {
        const parentTag = node.parentElement?.tagName;
        if (parentTag && SKIP_TAGS.has(parentTag)) {
          return NodeFilter.FILTER_REJECT;
        }
        if (!node.nodeValue || !ORPHAN_REGEX.test(node.nodeValue)) {
          return NodeFilter.FILTER_SKIP;
        }
        return NodeFilter.FILTER_ACCEPT;
      },
    },
  );

  const nodes = [];
  while (walker.nextNode()) {
    nodes.push(walker.currentNode);
  }
  nodes.forEach(replaceOrphansInTextNode);
};

// Initial pass after first render.
fixOrphans(document.body);

// Observe future changes (route changes, async content, etc.).
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        replaceOrphansInTextNode(node);
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        fixOrphans(node);
      }
    });
  });
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});